export async function fetchJson<T>(url: string): Promise<T | null> {
  try {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
    if (response.ok) {
      return await response.json()
    }
  } catch {
    // Network failure
  }
  return null
}
